import { Flex, FlexProps } from 'styled-system/jsx';

import { HighLow24hDayStat } from './HighLow24h';
import { Price24hDayStat } from './Price24h';

export const DayStats = (p: FlexProps) => {
  return (
    <Flex justifyContent="space-between" {...p}>
      <Price24hDayStat />
      {/* expected to rehydrate */}
    </Flex>
  );
};
